import { makeStyles } from 'tss-react/mui';
import { BLACK } from 'src/global/theme/colors';

export const styles = makeStyles()(() => {
  return {
    buttonLabel: {
      backgroundColor: 'transparent',
      color: BLACK,
      display: 'flex',
      padding: 4,
      fontSize: 13,
      justifyContent: 'left',
      textTransform: 'capitalize',
      '& .MuiButton-startIcon': {
        margin: 0
      },
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    wrapperIcon: {
      '&:hover': {
        backgroundColor: 'transparent !important'
      }
    },
    moreIcon: {
      width: 30,
      '&:hover': {
        backgroundColor: 'transparent !important'
      }
    },

    cardActions: {
      right: 0,
      justifyContent: 'flex-end',
      position: 'absolute',
      bottom: -8
    },
    linkCard: {
      textDecoration: 'none',
      fontSize: 13,
      color: BLACK,
      textTransform: 'capitalize'
    }
  };
});
